import React from 'react'
import Layout from '../Layout'
import ResourceForm from '../../../Components/ResourceForm'
import FormFieldController from '../../../Components/FormFieldController'
import BackLink from '../../../Components/BackLink'
import CurrentImagePreview from '../../../Components/CurrentImagePreview'
import { facilitySchema } from '../../../schemas'

export default function Edit({ account, accounts, navigation, facility }) {
  return (
    <Layout
      account={account}
      accounts={accounts}
      navigation={navigation}
      title={`Edit: ${facility.name}`}
    >
      <BackLink href="/manage/facilities">Back to Facilities</BackLink>

      <div className="bg-white shadow rounded-lg">
        <ResourceForm
          schema={facilitySchema}
          resource="facility"
          endpoint={`/manage/facilities/${facility.id}`}
          method="patch"
          backLink="/manage/facilities"
          submitLabel="Save Changes"
          defaultValues={{
            name: facility.name || '',
            description: facility.description || '',
            opening_hours: facility.opening_hours || '',
            link: facility.link || '',
            email: facility.email || '',
            phone: facility.phone || '',
            header_image: null
          }}
        >
          {({ control, errors }) => (
            <>
              <FormFieldController
                control={control}
                name="name"
                label="Name"
                required
                errors={errors}
              />

              <FormFieldController
                control={control}
                name="description"
                label="Description"
                type="textarea"
                rows={2}
                errors={errors}
              />

              <FormFieldController
                control={control}
                name="opening_hours"
                label="Opening Hours"
                errors={errors}
              />

              <div className="grid grid-cols-2 gap-4">
                <FormFieldController
                  control={control}
                  name="email"
                  label="Email"
                  type="email"
                  errors={errors}
                />
                <FormFieldController
                  control={control}
                  name="phone"
                  label="Phone"
                  errors={errors}
                />
              </div>

              <FormFieldController
                control={control}
                name="link"
                label="Website"
                type="url"
                errors={errors}
              />

              <CurrentImagePreview
                url={facility.header_image_url}
                alt={facility.name}
                className="h-24 rounded-lg object-cover"
              />

              <FormFieldController
                control={control}
                name="header_image"
                label={facility.header_image_url ? "Replace Image" : "Header Image"}
                type="file"
                accept="image/*"
                hint={facility.header_image_url ? "Leave empty to keep current image" : undefined}
                errors={errors}
              />
            </>
          )}
        </ResourceForm>
      </div>
    </Layout>
  )
}
